module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.mushroomSend), function(item, index) {
    return _c('tr', {
      staticClass: "text-left"
    }, [_c('td', [_vm._v("\n                  " + _vm._s(index + 1) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v("\n                " + _vm._s(item.note) + " "), _c('br'), _vm._v("\n                " + _vm._s(item.created_at) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.user))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ans_rmsc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ans_dcms))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": _vm.getUrlApprove(item.upload_code),
        "target": "_blank"
      }
    }, [_vm._v(" ตอบกลับ ")])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ลำดับ")]), _vm._v(" "), _c('th', [_vm._v("ข้อสงสัย")]), _vm._v(" "), _c('th', [_vm._v("ผู้ส่ง")]), _vm._v(" "), _c('th', [_vm._v("ความเห็นผู้เชี่ยวชาญ ศวก.")]), _vm._v(" "), _c('th', [_vm._v("ความเห็นผู้เชี่ยวชาญกรมวิทย์ฯ")]), _vm._v(" "), _c('th', [_vm._v("จัดการ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb006a06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SendMushRoom.vue
// module id = 1096
// module chunks = 1